/* Uttariya — Filter Drawer JS v2 */
(function () {
  'use strict';

  var openBtn  = document.getElementById('UttFilterOpen');
  var closeBtn = document.getElementById('UttFilterClose');
  var drawer   = document.getElementById('UttFilterDrawer');
  var bg       = document.getElementById('UttFilterBg');
  var clearBtn = document.getElementById('UttFilterClear');
  var form     = document.getElementById('UttFilterForm');
  var badge    = document.getElementById('UttFilterCount');

  if (!drawer) return;

  /* ── Open / Close ── */
  function openDrawer() {
    drawer.classList.add('open');
    if (bg) bg.classList.add('open');
    document.body.style.overflow = 'hidden';
    if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
    drawer.focus();
  }
  function closeDrawer() {
    drawer.classList.remove('open');
    if (bg) bg.classList.remove('open');
    document.body.style.overflow = '';
    if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
  }
  if (openBtn)  openBtn.addEventListener('click', openDrawer);
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  if (bg)       bg.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  /* ── Section accordion ── */
  document.querySelectorAll('.utt-fd-sec-head').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var open = btn.getAttribute('aria-expanded') !== 'false';
      btn.setAttribute('aria-expanded', open ? 'false' : 'true');
      var body = btn.nextElementSibling;
      if (body) body.classList.toggle('open', !open);
    });
  });

  /* ── Price sliders ── */
  var rMin = document.getElementById('UttRangeMin');
  var rMax = document.getElementById('UttRangeMax');
  var dMin = document.getElementById('UttPriceMinDisplay');
  var dMax = document.getElementById('UttPriceMaxDisplay');
  var iMin = document.getElementById('UttPMin');
  var iMax = document.getElementById('UttPMax');

  function syncPrice() {
    if (!rMin || !rMax) return;
    var lo = parseInt(rMin.value), hi = parseInt(rMax.value);
    if (lo >= hi - 50) {
      if (document.activeElement === rMin) lo = hi - 50;
      else hi = lo + 50;
      rMin.value = lo; rMax.value = hi;
    }
    if (dMin) dMin.textContent = lo;
    if (dMax) dMax.textContent = hi;
    if (iMin) iMin.value = lo;
    if (iMax) iMax.value = hi;
    countFilters();
  }
  if (rMin) rMin.addEventListener('input', syncPrice);
  if (rMax) rMax.addEventListener('input', syncPrice);
  if (iMin) iMin.addEventListener('change', function () { if (rMin) { rMin.value = iMin.value; syncPrice(); } });
  if (iMax) iMax.addEventListener('change', function () { if (rMax) { rMax.value = iMax.value; syncPrice(); } });

  /* ── Availability pill fallback (for browsers without :has) ── */
  document.querySelectorAll('.utt-avail-pill').forEach(function (pill) {
    var radio = pill.querySelector('input[type="radio"]');
    if (!radio) return;
    radio.addEventListener('change', function () {
      document.querySelectorAll('.utt-avail-pill').forEach(function (p) { p.classList.remove('selected'); });
      pill.classList.add('selected');
      countFilters();
    });
  });

  /* ── Filter count badge ── */
  function countFilters() {
    var n = 0;
    if (rMin && rMax) {
      if (parseInt(rMin.value) > parseInt(rMin.min) || parseInt(rMax.value) < parseInt(rMax.max)) n++;
    }
    if (form) {
      var avail = form.querySelector('input[name="avail"]:checked');
      if (avail && avail.value !== '') n++;
      var colors = form.querySelectorAll('input[name="color"]:checked');
      if (colors.length) n++;
    }
    if (badge) {
      badge.textContent = n;
      badge.style.display = n > 0 ? 'inline-flex' : 'none';
    }
  }

  if (form) {
    form.querySelectorAll('input').forEach(function (inp) {
      inp.addEventListener('change', countFilters);
    });
  }

  /* ── Clear ── */
  if (clearBtn) {
    clearBtn.addEventListener('click', function () {
      if (rMin) rMin.value = rMin.min;
      if (rMax) rMax.value = rMax.max;
      var firstAvail = form && form.querySelector('input[name="avail"]');
      if (firstAvail) {
        firstAvail.checked = true;
        document.querySelectorAll('.utt-avail-pill').forEach(function (p) { p.classList.remove('selected'); });
        var firstPill = document.querySelector('.utt-avail-pill');
        if (firstPill) firstPill.classList.add('selected');
      }
      if (form) form.querySelectorAll('input[name="color"]').forEach(function (cb) { cb.checked = false; });
      syncPrice();
      countFilters();
    });
  }

  /* ── Init ── */
  syncPrice();
  countFilters();

}());
